<template>
  <div class="dropdown" @mouseover="Fn" @mouseleave="isActive = false" :class="{'is-active is-active-menu': isActive}">
    <div class="dropdown-trigger">
      <div aria-haspopup="true"  aria-controls="dropdown-menu">
        <a href="#" @mouseover.native="revealDropdown" class="is-capitalized menu">
          {{route}}
        </a>
      </div>
    </div>
    <div class="dropdown-menu" ref="dropdown" role="menu">
      <div class="flex has-primary-background menu-content">
          <div v-if="solutions" v-for="list in itemsObj">
            <p class="is-bold is-white dropdown-item is-active category">{{list[0].value}}</p>
            <router-link 
              :to="`/${route}/${item.value}`" 
              class="is-white dropdown-item is-active is-hoverable"
              v-for="(item, index) in list" 
              v-if="index > 0"
            >
              {{item.value.replace(/-/g, " ")}}
            </router-link>
          </div>
          <div v-if="capabilities"> 
            <div v-for="(item,index) in itemsObj">
              <!-- <p class="is-bold is-white">{{item.value}}</p> -->
              <router-link 
               :to="`/${route}/${item.value}`"
               class="is-white dropdown-item is-active is-hoverable"
               >
                {{item.value.replace(/-/g, " ")}}
              </router-link>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['route', 'itemsObj', 'solutions', 'capabilities', 'defaultRoute'],
    data() {
      return {
        isActive: false,
      }
    },
    methods: {
      Fn() {
        this.isActive = true;
        this.revealDropdown();
      },
      revealDropdown(e) {
        // let rt = window.innerWidth - this.$refs.dropdown.getBoundingClientRect().right;
        // console.log('window: ' + window.innerWidth);
        // console.log('div: ' + this.$refs.dropdown.getBoundingClientRect().right);
        let overflow = this.$refs.dropdown.getBoundingClientRect().right - window.innerWidth;
        if (overflow > 0) {
          console.log('hi')
          this.$refs.dropdown.style.left = (overflow + 50) * -1 + 'px'
        }
        // overflow > 0 ?  : '';
        // console.log(overflow);
      }
    }
  };
</script>
<style lang="scss" scoped>
.category {
  font-size: 1rem;
}
.menu-content {
  border-top: 1px solid rgba(0,0,0,.5);
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  box-shadow: 1px 15px 60px rgba(0,0,0,.3);
}
.dropdown {
  height: 100%;
}
.dropdown-menu {
  // color: white;
  // margin-top: 8px;
  cursor: default !important;
  padding-top: 0px;
  a {
    &:hover {
      color: white !important;
    }
    &:active {
      color: white !important;
    }
    &:visited {
      color: white !important;
    }
  }
}
a.dropdown-item {
  border-radius: 5px;
  &:hover {
    background: #c86a25;
  }
}
.dropdown-menu {
  display: block !important;
  visibility: hidden;
  max-width: 100rem;
  opacity: 0;
  .is-active {
    &:hover {
      // font-weight: bold !important;
    }
  }
}
.is-capitalized {
  font-size: 1.1rem;
}
.is-active-menu {
  .dropdown-menu {
    visibility: visible !important;
    opacity: 1;
    transition: .5s ease all;
  }
}
.transparent-background {
  background: inherit !important;
}
</style>



// WEBPACK FOOTER //
// Dropdown.vue?4f38c992